<!--
 * @Author: quwandong
 * @Date: 2022-05-17 09:21:57
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-02-07 10:52:26
 * @FilePath: /adm.xiangli360.com/src/views/Cooperative/BdOrder/List.vue
 * @Description: 北斗订单列表
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="card-box" v-if="proTotalList.length > 0">
      <el-row :gutter="16">
        <el-col :span="6" v-for="(item, index) in proTotalList" :key="index">
          <div class="top-card">
            <div class="top-card-title">
              <i :class="getIconClassByCategory(item.category)"></i>
              <span>{{ item.category }}</span>
            </div>
            <div class="top-card-content">
              <div class="content-box">
                <div class="text-bold">{{ item.number || 0 }}</div>
                <div class="text-gray">销售台数（台）</div>
              </div>
              <div class="content-box">
                <div class="text-bold">{{ item.total || 0 }}</div>
                <div class="text-gray">销售金额（元）</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main">
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item>
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 300px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filterForm.orderNumber"
              placeholder="订单编号"
              prop="orderNumber"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="filterForm.statusFlag"
              prop="statusFlag"
              placeholder="订单状态"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="(item, index) in uniqeGlobalDict$$.bdOrderStatus"
                :key="index"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!$route.query.$businessName">
            <el-input
              v-model="filterForm.cooperativeName"
              placeholder="采购合作社名称"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="filterForm.title"
              prop="title"
              placeholder="北斗终端类型"
              style="width: 150px"
            >
              <el-option
                v-for="(item, index) in dicts.bdTerminalType"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table
        :data="tableData"
        v-loading="pagination.loading"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="订单日期"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderNumber"
          label="订单编号"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusFlag"
          label="订单状态"
          width="120"
          align="center"
          :formatter="statusFilter"
        >
        </el-table-column>
        <el-table-column
          prop="cooperativeName"
          label="采购合作社"
          align="center"
          min-width="200"
        >
        </el-table-column>
        <el-table-column
          prop="saleNumTotal"
          label="商品数量"
          width="90"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="saleAmountTotal"
          label="订单金额（元）"
          align="center"
          width="140"
        >
        </el-table-column>
        <el-table-column
          prop="shopTitle"
          label="商品"
          width="360"
          align="center"
        >
          <template slot-scope="{ row }">
            <div class="ellipsis" :title="row.shopTitle" style="width: 340px">
              {{ row.shopTitle }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="goDetail(row.id)"
            >
              订单查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.size"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
export default {
  name: 'BdOrderList',
  $dictKeyList: [
    {
      key: 'bdOrderStatus',
      name: '北斗订单状态',
    },
  ],
  data() {
    return {
      filterForm: {
        dateRange: [],
        orderNumber: '', // 订单编号
        statusFlag: '', // 订单状态
        cooperativeName: '', // 采购合作社名称
        title: '', // 北斗终端类型
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0,
        loading: false,
      },
      tableData: [],
      dicts: {
        bdTerminalType: [], // 产品
      }, // 字典数据
      proTotalList: [], // 产品统计列表
    }
  },
  mounted() {
    this.getDicts()
    this.getOrderTotal()
    this.getBdOrderList()
  },
  methods: {
    /**
     * @description: 获取字典
     * @Author: quwandong
     * @Date: 2022-05-17 19:35:48
     */
    async getDicts() {
      try {
        const productRes = await this.$http.bdOrder.getProductList()
        this.dicts.bdTerminalType = [
          {
            label: '全部',
            value: 0,
          },
          ...productRes.data.map((item) => ({
            label: item,
            value: item,
          })),
        ]
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取统计详情
     * @Author: quwandong
     * @Date: 2022-05-17 18:56:34
     */
    async getOrderTotal() {
      try {
        const res = await this.$http.bdOrder.getStatistics({
          masterId: this.$route.query.$businessAccountId,
        })
        this.proTotalList = res.data
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @description: 获取北斗订单列表
     * @Author: quwandong
     * @Date: 2022-05-17 14:08:47
     */
    async getBdOrderList() {
      try {
        this.pagination.loading = true
        const [startTime, endTime] = this.filterForm.dateRange
        const { orderNumber, title, statusFlag, cooperativeName } =
          this.filterForm
        let params = {
          startTime,
          endTime,
          currentPage: this.pagination.page,
          pageSize: this.pagination.size,
          masterId: this.$route.query.$businessAccountId,
        }

        title && (params.title = title)
        statusFlag && (params.statusFlag = statusFlag)
        orderNumber && (params.orderNumber = orderNumber)
        cooperativeName && (params.cooperativeName = cooperativeName)

        const res = await this.$http.bdOrder.getOrderlist(params)
        this.tableData = res.data.content.map((item) => {
          return {
            ...item,
            shopTitle: item.productList
              ? item.productList.map(({ title }) => title).join(',')
              : '',
          }
        })
        if (this.pagination.page == 1) {
          this.pagination.total = res.data.recordTotal
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.pagination.loading = false
      }
    },
    /**
     * @description: 条件查询
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:07
     */
    handleFilter() {
      this.pagination.page = 1
      this.getBdOrderList()
    },
    /**
     * @description: 重置查询表单
     * @param formName
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:27
     */
    handleReset() {
      this.filterForm.dateRange = []
      this.filterForm.orderNumber = ''
      this.filterForm.statusFlag = ''
      this.filterForm.title = ''
      this.filterForm.cooperativeName = ''
      this.$nextTick(() => {
        this.handleFilter()
      })
    },
    /**
     * @description: 点击分页
     * @Author: quwandong
     * @Date: 2022-05-17 14:05:53
     */
    handleCurrentChange(val) {
      this.pagination.page = val
      this.getBdOrderList()
    },
    /**
     * @description: 跳转详情页面
     * @param id
     * @Author: quwandong
     * @Date: 2022-05-17 14:24:25
     */
    goDetail(id) {
      this.$router.push({
        path: '/cooperative/bdOrder/detail',
        query: { id },
      })
    },
    /**
     * @description: 状态转换 key 转 text
     * @param value 要转换的值
     * @Author: quwandong
     * @Date: 2022-05-17 19:59:54
     */
    statusFilter(row) {
      const value = row.statusFlag
      if (!value) return ''

      console.log(this.uniqeGlobalDict$$.bdOrderStatus, value)

      const target = this.uniqeGlobalDict$$.bdOrderStatus.find(
        (item) => item.code == value
      )

      return target ? target.name : ''
    },
    /**
     * @description: 获取统计列表的图标class
     * @param undefined
     * @Author: quwandong
     * @Date: 2022-05-17 20:25:43
     */
    getIconClassByCategory(category) {
      if (category === '定位终端') {
        return 'first'
      }

      if (category === '作业监控终端') {
        return 'second'
      }

      if (category === '自动驾驶终端') {
        return 'third'
      }

      if (category === '通讯服务费') {
        return 'fourth'
      }

      return 'first'
    },
  },
}
</script>

<style lang="scss" scoped>
.card-box {
  padding: 10px 16px 0 16px;
  .top-card {
    height: 150px;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 22px 0;
    box-sizing: border-box;
    margin-bottom: 20px;

    .top-card-title {
      padding: 0 22px;
      box-sizing: border-box;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #666666;
      display: inline-flex;
      align-items: center;

      i {
        display: inline-block;
        width: 21px;
        height: 22px;
        margin-right: 8px;

        &.first {
          background: url('~assets/icon_zhongduan.png');
          background-size: 100% 100%;
        }

        &.second {
          background: url('~assets/icon_zhongduan2.png');
          background-size: 100% 100%;
        }

        &.third {
          background: url('~assets/icon_zidongjiashi.png');
          background-size: 100% 100%;
        }

        &.fourth {
          background: url('~assets/icon_tongxunfei.png');
          background-size: 100% 100%;
        }
      }
    }

    .top-card-content {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .content-box {
        width: 50%;
        text-align: center;

        .text-bold {
          font-size: 30px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #222222;
        }

        .text-gray {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #888888;
        }
      }
    }
  }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
